import _ from "lodash";
import { colors, createMuiTheme, responsiveFontSizes } from "@material-ui/core";

import typography from "./typography";

const baseOptions = {
  direction: "ltr",
  typography,
  overrides: {
    MuiPickersModal: {
      dialogRoot: {
        padding: "0px",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          borderBottom: "none",
        },
        "&::after": {
          borderBottom: "none",
        },
      },
    },
    MuiDialog: {
      paperWidthSm: {
        maxWidth: "460px",
      },
    },
    MuiFormControl: {
      root: {
        width: "100%",
      },
    },
    paperWidthSm: {
      maxWidth: "600px",
      padding: "20px 30px",
    },
    MuiCollapse: {
      wrapperInner: {
        paddingLeft: "44px",
      },
    },

    MuiInputAdornment: {
      positionStart: {
        paddingLeft: "14px",
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: "none",
        fontSize: "12px",
        textAlign: "left",
      },
    },
    MuiCheckbox: {
      root: {
        color: "#004869",
      },
    },
    MuiFormHelperText: {
      contained: {
        marginLeft: "0px !important",
        // color: "rgb(255, 125, 104) !important",
      },
    },
    MuiOutlinedInput: {
      multiline: {
        height: "100px !important",
      },
    },
    MuiPickersCalendarHeader: {
      iconButton: {
        backgroundColor: "transparent",
      },
    },
    MuiPickerDTToolbar: { toolbar: { borderRadius: "8px 8px 0px 0px" } },

    MuiButton: {
      root: {
        "&.Mui-disabled": {
          color: "rgb(112, 107, 107)",
        },
      },
      contained: {
        fontSize: "14px !important",
        fontWeight: "300",
        borderRadius: "5px",
        whiteSpace: "pre",
        padding: "10px 20px",
      },
      outlined: {
        fontSize: "14px !important",
        fontWeight: "300",
        borderRadius: "50px",
        whiteSpace: "pre",
        padding: "10px 20px",
      },
      outlinedSizeLarge: {
        padding: "7px 35px",
      },
      containedSizeLarge: {},
    },
    MuiPaginationItem: {
      page: {
        "&.Mui-selected": {
          backgroundColor: "#0666EB",
        },
        "&.Mui-disabled": {
          backgroundColor: "rgb(62 57 57 / 28%)",
        },
      },
      root: {
        color: "#000",
      },
      outlined: {
        backgroundColor: "#0666EB",
      },
    },
  },
};

const themesOptions = [
  {
    name: "LIGHT",
    overrides: {
      MuiMenu: {
        list: {
          outline: "0",
          background: "#f3f5f7",
          color: "#000",
        },
      },
      MuiDialog: {
        paper: {
          margin: "32px",
          backgroundColor: "#ffffff",
          padding: "20px 30px",
          position: "relative",
          overflowY: "auto",
          color: "#fff !important",
          borderRadius: "10px !important",
          "@media(max-width:767px)": {
            padding: "10px",
          },
        },
      },
      MuiSwitch: {
        switchBase: {
          color: "#FF6600 !important",
        },
        track: {
          backgroundColor: "#a8a4a4",
          opacity: "1",
        },
      },
      MuiInputBase: {
        root: {
          color: "#000",
          height: "50px",

          background: "rgba(0, 0, 0, 0.04)",
          borderRadius: "10px !important",
          // height: "50px !important",
        },
      },
      MuiSelect: {
        icon: {
          color: "#000",
        },
      },
      MuiTableHead: {
        root: {
          background: "transparent",
          borderTop: "1px solid #b3aaaa",
        },
      },
      MuiTableBody: {
        root: {
          background:
            "linear-gradient(152.97deg, rgb(255 255 255 / 65%) 0%, rgb(62 60 60 / 27%) 100%)",
        },
      },
      MuiTableRow: {
        root: {
          borderBottom: "1px solid #b3aaaa",
          "&:hover": {
            backgroundColor: "#00000017",
          },
          "&:last-child": {
            borderBottom: "none",
          },
        },
      },
      MuiTableCell: {
        head: {
          padding: "8px 16px",
          fontWeight: "300",
          color: "#212121",
          whiteSpace: "pre",
        },
        body: {
          color: "#212121",
          whiteSpace: "pre",
        },
      },

      MuiButton: {
        containedPrimary: {
          backgroundColor: "#D4D4D4",
          borderRadius: "10px",
          color: "#7D7D7D",
          fontSize: "14px",
          fontWeight: "600",
          height: "45px",
          lineHeight: " 21px",
          padding: "10px 39px",
          marginRight: "10px",
          border: "1px solid #DA8300",
          "&:hover": {
            color: "#fff",
            background: "#FF6C64 !important",
            border: "1px solid #FF6C64",
            backgroundColor: "#FF6C64 !important",
          },
        },

        containedSecondary: {
          borderRadius: "10px",
          color: "#7D7D7D",
          fontSize: "14px",
          fontWeight: "600",
          height: "45px",
          lineHeight: " 21px",
          padding: "10px 39px",
          marginRight: "10px",

          backgroundColor: "#D4D4D4",
          // boxShadow:
          //   "0 1px 0 0 #ad5165, 0 -1px 0 0 #7e46a1, 1px 0 0 0 #f5673f, -1px 0 0 0 #f5673f, 1px -1px 0 0 #f5673f, -1px 1px 0 0 #f5673f, 1px 1px 0 0 #f5673f, -1px -1px 0 0 #f5673f",
          backgroundColor: "transparent",
          "&:hover": {
            color: "#fff",
            background: "#FF6C64 !important",
            border: "1px solid #FF6C64",
            backgroundColor: "#FF6C64 !important",
          },
        },

        contained: {
          "&.Mui-disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.03) ",
          },
        },
        outlinedPrimary: {
          color: "#000",
          border: "1px solid #000 !important",
          "&:hover": {
            color: "#fff",
            boxShadow: "none !important",
            backgroundColor:
              "linear-gradient(180deg, #FDA645 0%, #FF00CD 100%)",
            // backgroundColor: "#51ACED !important",
            // border: "1px solid #51ACED !important",
          },
        },
      },
      MuiPickersCalendarHeader: {
        dayLabel: { color: "#000" },
      },
      MuiPickersClockNumber: { clockNumber: { color: "#000" } },
      MuiPickersDay: {
        day: {
          color: "#000",
        },
      },
      MuiPaginationItem: {
        root: {
          color: "#000",
        },
      },
      MuiPaginationItem: {
        root: {
          color: "#ffffff",
        },
        page: {
          "&.Mui-disabled": {
            backgroundColor: "transparent",
          },
          "&.Mui-disabled": {
            opacity: 1,
          },
        },
      },
      MuiPaper: {
        root: { color: "#000" },
        elevation2: {
          position: "relative",
          zIndex: "999",
          overflow: "hidden",
          padding: "40px",
          // boxShadow: "-8px -8px 13px 0px #ffffff, 6px 13px 20px #d2d1db",
          borderRadius: "20px !important",
          backgroundColor: "#ffffff",
          "@media(max-width:767px)": {
            padding: "20px !important",
          },
        },
      },
      MuiIconButton: {
        root: {
          color: "#000000",
        },
      },

      MuiOutlinedInput: {
        inputMultiline: {
          padding: "1px !important",
        },
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
            boxShadow: "none",
          },
        },
        notchedOutline: {
          background: "rgba(0, 0, 0, 0.07)",
          borderColor: "rgb(230 226 230)",
        },
        input: {
          borderRadius: "10px",
          color: "#000",
          padding: "16px 14px",
          "&:-webkit-autofill": {
            "-webkit-background-clip": "text !important",
            // transitionDelay: "9999s",
            "caret-color": "transparent",
            "-webkit-box-shadow": "0 0 0 100px transparent inset",
            "-webkit-text-fill-color": "#000",
          },
          "&:-internal-autofill-selected": {
            color: "#fff",
          },
        },
      },
    },
    typography: {
      fontFamily: "'Readex Pro', sans-serif",
    },
    palette: {
      background: {
        card: "#F0F0F0",
        tab: "rgba(191, 111, 6, 0.2)",
        header: "#fff",
        default: "#F5F5F5",
        price: "#fef7fa",
        pricename: "#fef7fa",
        blackCard: "#fef7fa",
        tablehead: "#fef7fa",
        head: "#fff",
        active: "#DA8300",
        bannerBg: "#FFFFFF",
        pricebg: "#F9F9F9;",
      },
      primary: {
        main: "#000000", //black
      },
      secondary: {
        main: "#212121", //black
        icons: "#009900", //white
      },
      text: {
        primary: "#000", //black
        secondary: "rgba(33, 33, 33, 0.5)", //white
        gray: "#000",
        graydark: "#000",
        white: "#000",
        count: "#DA8300",
        countSub: " rgba(33, 33, 33, 0.6)",

        bannerText: "#272E35",
        bannerText1: "#FFFFFF",
      },
    },
  },
  {
    name: "DARK",
    overrides: {
      MuiDropzoneArea: {
        root: {
          backgroundColor: "#101010",
          border: "1px dashed rgba(255, 255, 255, 0.3)",
          borderColor: "rgba(255, 255, 255, 0.3)",
          minHeight: "228px",
        },
      },
      MuiAutocomplete: {
        popper: {
          background: "#1C1C1C",
          borderRadius: "10px",
        },
      },
      MuiPickersClockNumber: {
        clockNumber: {
          color: "#000",
        },
      },
      MuiMenu: {
        list: {
          outline: "0",
          background: "#f3f5f7",
          color: "#000",
        },
      },
      MuiOutlinedInput: {
        multiline: {
          height: "100px",
        },
      },
      MuiDialog: {
        paper: {
          padding: "20px 30px",
          background: "#fff",
          borderRadius: "10px",
          overflow: "hidden",
          position: "relative",
          "@media(max-width:767px)": {
            padding: "10px",
          },
        },
      },
      MuiSwitch: {
        switchBase: {
          color: "#FF6600 !important",
        },
        track: {
          backgroundColor: "gray",
          opacity: "1",
        },
      },
      MuiPickersDay: {
        day: {
          color: "#000",
        },
      },
      MuiPickersYear: {
        root: {
          color: "#000",
        },
      },
      MuiPickersCalendarHeader: {
        dayLabel: { color: "#fff" },
      },
      MuiTableHead: {
        root: {
          background: "transparent",
          borderTop: "1px solid #636262",
          "&:hover": {
            backgroundColor: "none",
          },
        },
      },
      MuiTableBody: {
        root: {
          background:
            "linear-gradient(152.97deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)",
        },
      },
      MuiTableRow: {
        root: {
          borderBottom: "1px solid #636262",
          "&:hover": {
            backgroundColor: "#ffffff14",
          },
          "&:last-child": {
            borderBottom: "none",
          },
        },
      },
      MuiTableCell: {
        head: {
          padding: "8px 16px",
          fontWeight: "300",
          backgroundColor: "#0666EB",
          color: "#fff",
          whiteSpace: "pre",
        },
        body: {
          color: "#0D0D0D",
          whiteSpace: "pre",
        },
      },
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: "#0666EB",
        },
      },

      MuiPickersSlideTransition: {
        transitionContainer: {
          "& > *": {
            color: "#000",
          },
        },
      },

      MuiInputBase: {
        root: {
          color: "#0D0D0D",
          cursor: "text",
          display: "inline-flex",
          position: "relative",
          fontSize: "12px",
          background: "#f3f5f7",
          boxSizing: "border-box",
          alignItems: "center",
          fontFamily: "'Readex Pro', sans-serif",
          fontWeight: "300",
          lineHeight: "1.1876em",
          borderRadius: "50px",
          height: "50px",
          // boxShadow: "0px 0px 53px rgba(0, 0, 0, 0.25)",
          borderRadius: "10px !important",
          // height: "50px !important",
        },
      },
      MuiSelect: {
        icon: {
          color: "#fff",
        },
      },

      MuiButton: {
        containedPrimary: {
          backgroundColor: "#FF6C64",
          borderRadius: "10px",
          color: "#fff",
          fontSize: "14px",
          fontWeight: "600",
          height: "45px",
          lineHeight: " 21px",
          padding: "10px 39px",
          marginRight: "10px",
          border: "1px solid transparent",
          "&:hover": {
            color: "#fff",
            background: "rgba(92, 183, 226, 1) !important",
            border: "1px solid rgba(92, 183, 226, 1)",
            backgroundColor: "rgba(92, 183, 226, 1) !important",
          },
        },
        containedSecondary: {
          borderRadius: "10px",
          color: "#fff",
          fontSize: "14px",
          fontWeight: "600",
          height: "45px",
          lineHeight: " 21px",
          padding: "10px 39px",
          marginRight: "10px",

          
          backgroundColor:  "#D4D4D4 !important",
          "&:hover": {
            color: "#fff",
            background: "#FF6C64 !important",
            border: "1px solid #FF6C64 ",
            backgroundColor: "#FF6C64 !important",
          },
        },
        contained: {
          "&.Mui-disabled": {
            color: "#65606045",
            backgroundColor: "rgb(103 93 93 / 30%)",
          },
        },
      },
      MuiPaginationItem: {
        root: {
          color: "#ffffff",
        },
        page: {
          "&.Mui-disabled": {
            backgroundColor: "transparent",
          },
        },
      },

      MuiPaper: {
        root: {
          color: "#000",
          backgroundColor: "rgba(255, 255, 255, 0.03)",
        },
        elevation2: {
          position: "relative",
          zIndex: "999",
          padding: "40px",
          background: "#fff",
          overflow: "hidden",
          boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
          borderRadius: "20px !important",
          "@media(max-width:767px)": {
            padding: "20px !important",
          },
        },
      },
      MuiIconButton: {
        root: {
          color: "#0D0D0D",
        },
      },
      MuiOutlinedInput: {
        inputMultiline: {
          padding: "1px !important",
        },
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
            boxShadow: "none",
          },
        },
        notchedOutline: {
          background: "rgba(255, 255, 255, 0.025)",
          borderColor: "rgba(255, 255, 255, 0.025)",
        },
        input: {
          borderRadius: "10px",
          color: "#0D0D0D",
          padding: "16px 14px",
          "&:-webkit-autofill": {
            "-webkit-background-clip": "text !important",
            // transitionDelay: "9999s",
            "caret-color": "transparent",
            "-webkit-box-shadow": "0 0 0 100px transparent inset",
            "-webkit-text-fill-color": "#0D0D0D",
          },
          "&:-internal-autofill-selected": {
            color: "#0D0D0D",
          },
        },
      },
    },
    typography: {
      fontFamily: "'Readex Pro', sans-serif",
    },
    palette: {
      background: {
        card: "#1C1C1C",
        tab: "rgba(216, 125, 7, 0.2)",
        header: "#0D0D0D",
        default:
          "linear-gradient(152.97deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)",
        price: "#2B2B2B",
        pricename: "#474747",
        blackCard: "#1E1E1E",
        tablehead: "#1B1A1A",
        head: "#0D0D0D",
        active: "#246BFD",
        bannerBg: "#383838",
        pricebg: "#131313",
      },
      primary: {
        main: "#0D0D0D", //black
      },
      secondary: {
        main: "#0D0D0D", //white
        icons: "#FFFFFF", //white
      },
      text: {
        primary: "#FFFFFF", //white
        secondary: "rgba(222, 222, 222, 0.5)", //white
        gray: " #A9A9A9",
        graydark: "#A7A7A7",
        white: "#fff",
        count: "#F39200",
        countSub: "rgba(222, 222, 222, 0.6)",
        bannerText: "#212121",
        bannerText1: "#0D0D0D",
      },
    },
  },
];

export const createTheme = (config = {}) => {
  let themeOptions = themesOptions.find((theme) => theme.name === config.theme);

  if (!themeOptions) {
    console.warn(new Error(`The theme ${config.theme} is not valid`));
    [themeOptions] = themesOptions;
  }

  let theme = createMuiTheme(
    _.merge({}, baseOptions, themeOptions, { direction: config.direction })
  );

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
